import * as React from 'react'

export const CancelIcon: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="8.604"
      height="8.545"
      viewBox="0 0 8.604 8.545"
    >
      <g id="Component_48_87" data-name="Component 48 – 87" transform="translate(.302 .295)">
        <path
          id="Path_9357"
          strokeWidth="0.5px"
          d="M13.23 5.591a.6.6 0 0 0-.856 0L9.407 8.552 6.44 5.585a.6.6 0 0 0-.856.856l2.968 2.966-2.967 2.967a.6.6 0 0 0 .856.856l2.967-2.967 2.967 2.967a.6.6 0 0 0 .856-.856l-2.968-2.967L13.23 6.44a.608.608 0 0 0 0-.849z"
          data-name="Path 9357"
          transform="translate(-5.408 -5.408)"
        />
      </g>
    </svg>
  )
}
